import { useEffect, useRef, type ComponentProps } from 'react';
import { FiCalendar, FiChevronDown } from 'react-icons/fi';
import { AnalyticsDateRange } from './AnalyticsFilterBar';
import { formatRange, hktToday, validateRange } from '../utils/periodDashboard';

type Props = ComponentProps<typeof AnalyticsDateRange> & {
  appliedStart: string;
  appliedEnd: string;
};

/** Native disclosure keeps custom dates accessible without dominating every report. */
export default function AnalyticsDateControl({ appliedStart, appliedEnd, ...props }: Props) {
  const disclosure = useRef<HTMLDetailsElement>(null);
  const showYear = appliedStart.slice(0, 4) !== hktToday().slice(0, 4) || appliedEnd.slice(0, 4) !== hktToday().slice(0, 4);
  useEffect(() => { if (disclosure.current) disclosure.current.open = false; }, [appliedStart, appliedEnd]);
  return (
    <details className="analytics-date-control" ref={disclosure} onKeyDown={(event) => {
      if (event.key === 'Escape' && disclosure.current) {
        disclosure.current.open = false;
        disclosure.current.querySelector('summary')?.focus();
      }
    }}>
      <summary><FiCalendar aria-hidden="true" />{validateRange({ startDate: appliedStart, endDate: appliedEnd }).valid ? formatRange({ startDate: appliedStart, endDate: appliedEnd }, showYear) : 'Choose dates'}<FiChevronDown aria-hidden="true" /></summary>
      <div className="analytics-date-content"><AnalyticsDateRange {...props} /></div>
    </details>
  );
}
